import CourseSearch from '../course_search';
import uniqBy from 'lodash/uniqBy';

const nowAsISOString = () => (new Date(new Date().setHours(0, 0, 0, 0))).toISOString();

/**
 * A class that queries against the Elasticsearch Items database
 */
export default class SearchItems {
  constructor({ engine = 'items-st', filters = {} }) {
    this.engine = engine;

    this.courseSearch = new CourseSearch(
      engine
    );

    this.filtersQuery = Object.keys(filters)
      .map((key) => {
        const filtersAsArray = Array.isArray(filters[key]) ? filters[key] : [filters[key]];
        return filtersAsArray.map((filter) => `f_${key}=${filter}`).join('&');
      }).join('&');

    // "None:..." Hides parent items that are associated with CDP topic pages
    this.filters = {
      all: [
        { business_units: ['VSD', 'Camps', 'Courses'] },
        { start_dates: { gte: nowAsISOString() } }
      ],
      none: {
        exists: { field: 'topic_ids' }
      }
    };

    Object.keys(filters).forEach((key) => {
      this.filters.all.push({ [key]: filters[key] });
    });
  }

  formattedTitle(result) {
    if (result.instructor_names &&
      result.business_units &&
      result.business_units.indexOf('Celebrity') > -1) {
      return `${result.instructor_names.join(', ')} - ${result.title}`;
    } else {
      return result.title;
    }
  }

  formatSearchResult = (result) => {
    if (result.catalog_type === 'catalog-topics-v1') {
      return {
        type: 'topic',
        text: result.title_markdown,
        href: result.topic_page,
      };
    } else {
      return {
        type: 'item',
        text: this.formattedTitle(result),
        href: result.details_page
      };
    }
  }

  uniqueResults(results) {
    return uniqBy(results, ((result) => (`${result.href}::${result.text}`)));
  }

  /**
   * Performs a fetch against the Elasticsearch database for the given query.
   * @param {String} query - The string to query
   * @returns {Promise} - Promise containing the results as { type, text, href }
   */
  async search(query) {
    return this.courseSearch.client.search(query, {
      filters: this.filters,
      result_fields: ['id', 'title', 'details_page', 'business_units', 'instructor_names']
    })
      .then(({ rawResults }) => rawResults.map(this.formatSearchResult))
      .then((results) => this.uniqueResults(results));
  }
}
